export default "__VITE_ASSET__CoF0CbRH__"